export default __webpack_public_path__ + "static/media/report-generator.b15f9cd9.jpg";